import React from "react";

const SearchQueryParamsContext = React.createContext();
SearchQueryParamsContext.displayName = "SearchQueryParamsContext";

export const SearchQueryParamsProvider = SearchQueryParamsContext.Provider;
export const SearchQueryParamsConsumer = SearchQueryParamsContext.Consumer;

export default SearchQueryParamsContext;
